export class DataModelConnection {
    email: string = "";
    mdp: string = "";
}